   <p-dialog [modal]="true"
          [(visible)]="editPaymentPageDialog.visible"
          [style]="{width: '50rem'}"
          [closable]="false"
          [resizable]="false"
          [draggable]="false"
          styleClass="custom-header-dialog">
  <ng-template #header>
    <div>
      <span class="p-dialog-title">{{ i18n?.i18nLng()[editPaymentPageDialog?.i18nTitleKey] }}</span>
    </div>
    <p-button icon="pi pi-times"
              [text]="true"
              [rounded]="true"
              styleClass="p-dialog-close-button"
              severity="secondary"
              [attr.aria-label]="i18n.i18nLng()['CLOSE']"
              (click)="cancelEditPaymentPageData()"/>
  </ng-template>
  @switch (editPaymentPageDialog.type) {
    @case (PaymentPageDialogType.ADMINISTRATION) {
      <edit-form-administration-data [paymentPageData]="paymentPageData"
                                     [paymentPageInvalidFlags]="paymentPageInvalidFlags"
                                     [paymentMethodsList]="paymentPagePaymentTypes">
      </edit-form-administration-data>
    }
  }
  <ng-template #footer>
    <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelEditPaymentPageData()"/>
    <p-button [label]="i18n.i18nLng()['SAVE']" (onClick)="checkChangedPaymentPageData()"/>
  </ng-template>
</p-dialog>

@if (addPaymentPageDialog.visible) {
  <p-dialog [modal]="true"
            [(visible)]="addPaymentPageDialog.visible"
            [style]="{width: '50rem'}"
            [closable]="false"
            [resizable]="false"
            [draggable]="false"
            styleClass="custom-header-dialog">
    <ng-template #header>
      <div>
        <span class="p-dialog-title">{{ i18n?.i18nLng()['ADDPAYMENTPAGEBUTTON'] }}</span>
      </div>
      <p-button icon="pi pi-times"
                [text]="true"
                [rounded]="true"
                styleClass="p-dialog-close-button"
                severity="secondary"
                [attr.aria-label]="i18n.i18nLng()['CLOSE']"
                (click)="cancelAddPaymentPage()"/>
    </ng-template>
    <add-form-payment-page [paymentPageData]="newPaymentPageData" [paymentMethodsList]="paymentPagePaymentTypes"></add-form-payment-page>
    <ng-template #footer>
      <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelAddPaymentPage()"/>
      <p-button [label]="i18n.i18nLng()['SAVE']" [disabled]="newPaymentPageData?.name.trim().length === 0" (onClick)="saveNewPaymentPageData()"/>
    </ng-template>
  </p-dialog>
}
@if (paymentPageLinkDialog.visible) {
  <p-dialog [modal]="true"
            [focusOnShow]="false"
            [(visible)]="paymentPageLinkDialog.visible"
            [style]="{width: '52rem'}"
            [closable]="false"
            [resizable]="false"
            [draggable]="false"
            (visibleChange)="$event === false ? cancelAddPaymentPageLink() : null"
            styleClass="custom-header-dialog">
    <ng-template #header>
      <div>
        <span class="p-dialog-title">{{ i18n?.i18nLng()[paymentPageLinkDialog?.i18nTitleKey] }}</span>
      </div>
      <p-button icon="pi pi-times"
                [text]="true"
                [rounded]="true"
                styleClass="p-dialog-close-button"
                severity="secondary"
                [attr.aria-label]="i18n.i18nLng()['CLOSE']"
                (click)="cancelAddPaymentPageLink()"/>
    </ng-template>
    <p-stepper [(value)]="paymentPageLinkActiveStep" [linear]="true">
      <p-step-list>
        <p-step [value]="1">{{ i18n.i18nLng()['ADDPPLINKGLOBALSTEP'] }}</p-step>
        <p-step [value]="2">{{ i18n.i18nLng()['ADDPPLINKPAYMENTSTEP'] }}</p-step>
        <p-step [value]="3">{{ i18n.i18nLng()['ADDPPLINKPRESENTATIONSTEP'] }}</p-step>
        <p-step [value]="4">{{ i18n.i18nLng()['ADDPPLINKINTEGRATIONSTEP'] }}</p-step>
      </p-step-list>
    </p-stepper>
    @switch (paymentPageLinkActiveStep) {
      @case (1) {
        <add-form-payment-page-link-general [paymentPageLinkData]="paymentPageLinkData"
                                            [paymentPageLinkInvalidFlags]="paymentPageLinkInvalidFlags"
                                            (dataChanged)="linkDataChanged(paymentPageLinkActiveStep)">
        </add-form-payment-page-link-general>
      }
      @case (2) {
        <!-- force reinitialization of the components to reload available PaymentMethods in ngOnInit() if Payment-Page Status changes from live to test or test to live -->
        @if (paymentPageLinkActiveStep === 2) {
          <add-form-payment-page-link-payment [paymentPageLinkData]="paymentPageLinkData"
                                              [addPaymentPageLinkDialog]="paymentPageLinkDialog"
                                              [paymentPageLinkInvalidFlags]="paymentPageLinkInvalidFlags"
                                              [paymentMethodsList]="paymentPageLinkPaymentTypes"
                                              (dataChanged)="linkDataChanged(paymentPageLinkActiveStep)">
          </add-form-payment-page-link-payment>
        }
      }
      @case (3) {
        <add-form-payment-page-link-presentation [paymentPageLinkData]="paymentPageLinkData"
                                                 [paymentPageLinkInvalidFlags]="paymentPageLinkInvalidFlags"
                                                 (dataChanged)="linkDataChanged(paymentPageLinkActiveStep)">
        </add-form-payment-page-link-presentation>
      }
      @case (4) {
        <add-form-payment-page-link-integration [paymentPageLinkData]="paymentPageLinkData"
                                                [paymentPageLinkInvalidFlags]="paymentPageLinkInvalidFlags">
        </add-form-payment-page-link-integration>
      }
    }
    <ng-template #footer>
      <div class="flex w-full align-items-center justify-content-between">
        <div class="text-sm">
          <sup class="sps-sup">*</sup><span><i>{{ i18n.i18nLng()['REQUIREDHELP'] }}</i></span>
        </div>
        <div class="flex gap-2">
          @if (paymentPageLinkActiveStep === 4) {
            <p-button [label]="i18n.i18nLng()['CLOSE']" (onClick)="cancelAddPaymentPageLink()"/>
          } @else {
            <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelAddPaymentPageLink()"/>
            @if (paymentPageLinkActiveStep > 1 && paymentPageLinkActiveStep < 4) {
              <p-button [label]="i18n.i18nLng()['BACK']" icon="pi pi-arrow-left" [outlined]="true" (click)="previousLinkStep()"/>
            }
            @if (paymentPageLinkActiveStep === 3) {
              <p-button [label]="i18n.i18nLng()['SAVE']" icon="pi pi-arrow-right" iconPos="right" [disabled]="!dataValid" (onClick)="savePaymentPageLink()"/>
            } @else {
              <p-button [label]="i18n.i18nLng()['NEXT']" icon="pi pi-arrow-right" iconPos="right" [disabled]="!dataValid" (click)="nextLinkStep()"/>
            }
          }
        </div>
      </div>
    </ng-template>
  </p-dialog>
}

<div class="grid">
  <div class="col-12 xl:col-8">
    <p-card class="h-full">
      <ng-template pTemplate="title">
        <div class="flex flex-1 gap-2 align-self-stretch" [ngClass]="layoutService.isMobile() ? 'align-items-start' : 'align-items-center'">
          <div class="flex flex-1" [ngClass]="layoutService.isMobile() ? 'flex-column justify-content-center align-items-start gap-4' : 'align-items-center gap-3'">
            <div style="word-break: keep-all">{{ totalRecords.toString() + ' ' + i18n?.i18nLng()['PAYMENTLINKS'] }}</div>
          </div>
          @if (paymentPageData && (paymentPageData.status !== 'CLOSED')) {
            <!-- donation links are disabled!!!
            <p-menu #addlinkmenu
                    [model]="addLinkMenu"
                    [popup]="   true"
                    styleClass="popup-menu"
                    (onShow)="menuShown = true"
                    (onHide)="menuShown = false"
                    [pTooltip]="this.i18n.i18nLng()['ADDPAYMENTLINKINFO'] + ' ' + this.i18n.i18nLng()['ADDDONATIONLINKINFO']">
            </p-menu>
            <p-button [icon]="menuShown ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                      iconPos="right"
                      [label]="i18n?.i18nLng()['ADDPAYMENTLINK']"
                      [ariaLabel]="i18n?.i18nLng()['ADDPAYMENTLINK']"
                      (click)="addlinkmenu.toggle($event)"/>
            -->
            <p-button [label]="i18n?.i18nLng()['MENUADDPAYMENTLINK']"
                      [ariaLabel]="i18n?.i18nLng()['MENUADDPAYMENTLINK']"
                      [pTooltip]="this.i18n.i18nLng()['ADDPAYMENTLINKINFO']"
                      tooltipPosition="top"
                      (click)="showAddLinkDialog('PAYMENT')"/>
          }
        </div>
      </ng-template>
      @if (!paymentPageData) {
        <db-no-data-info i18nMessageKey="NOPAYMENTPAGEDATA"></db-no-data-info>
      } @else {
        <div [ngStyle]="{'height': (layoutService.usableContentHeight() - scrollHeightOffset) > minScrollHeight ? (layoutService.usableContentHeight() - scrollHeightOffset)  + 'px' : minScrollHeight + 'px'}">
          <p-table [value]="paymentPageLinks"
                   class="mt-2"
                   [selectionMode]="paymentPageData.status === 'CLOSED' ? null : 'single'"
                   [(selection)]="selectedRowData"
                   [paginator]="true"
                   [rows]="rows"
                   [rowsPerPageOptions]="rowsPerPageOptions"
                   [scrollable]="true"
                   scrollHeight="flex"
                   (onRowSelect)="onRowSelected($event)">
            <ng-template pTemplate="header">
              <tr>
                <th></th>
                <!--
                <th>{{ i18n?.i18nLng()['LINKTYPE'] }}</th>
                -->
                <th>{{ i18n?.i18nLng()['LINKNAME'] }}</th>
                <th>{{ i18n?.i18nLng()['PURPOSE'] }}</th>
                <th>{{ i18n?.i18nLng()['EXPIRATIONDATE'] }}</th>
                <th>{{ i18n?.i18nLng()['PAYMENTFREQUENCY'] }}</th>
                <th>{{ i18n?.i18nLng()['STATUS'] }}</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-link>
              <tr [pSelectableRow]="link">
                <td class="large-icon-cell">
                  @switch (link.type) {
                    @case ('PAYMENT') {
                      <i class="pi pi-money-bill"></i>
                    }
                    @case ('DONATION') {
                      <sps-custom-icon name="donate" alt="Spende (Donation)" [size]="21"></sps-custom-icon>
                    }
                  }
                </td>
                <!--
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
                  {{ i18n.i18nLng()[link.type] }}
                </td>
                -->
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
                  {{ link.name }}
                </td>
                <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
                  {{ link.purpose }}
                </td>
                @if (link.expirationDate === 'UNLIMITED') {
                  <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
                    -
                  </td>
                } @else {
                  <td>
                    {{ link.expirationDate | date : 'dd.MM.yyyy' }}
                  </td>
                }
                @if (link.paymentFrequency === 'ONETIME') {
                  <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
                    {{ i18n.i18nLng()['FREQUENCYONETIME'] }}
                  </td>
                } @else {
                  <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
                    {{ i18n.i18nLng()['FREQUENCYUNLIMITED'] }}
                  </td>
                }
                <td>
                  @if (link.enabled) {
                    <p-tag [value]="i18n.i18nLng()['ACTIVE']" severity="success" icon="pi pi-check"/>
                  } @else {
                    <p-tag [value]="i18n.i18nLng()['INACTIVE']" severity="danger" icon="pi pi-exclamation-triangle"/>
                  }
                </td>
                <td class="table-toggler-icon align-items-center" style="width: 28px">
                  <i class="pi pi-chevron-right"></i>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </p-card>
  </div>
  <div class="col-12 xl:col-4">
    <div class="grid">
      <div class="col-12">
        @if (!paymentPageData) {
          <p-card [header]="i18n.i18nLng()['ADMINISTRATION']">
            <db-no-data-info i18nMessageKey="NOPAYMENTPAGEDATA" [small]="true"></db-no-data-info>
          </p-card>
        } @else {
          <sps-payment-method-data-card [title]="i18n.i18nLng()['ADMINISTRATION']"
                                        [editable]="paymentPageData?.status !== 'CLOSED'"
                                        titleColumnWidth="120px"
                                        [tableData]="tableDataPaymentPageAdmin"
                                        (onEdit)="showEditDialog(PaymentPageDialogType.ADMINISTRATION)">
          </sps-payment-method-data-card>
        }
      </div>
      <div class="col-12">
        @if (!paymentPageData) {
          <p-card [header]="i18n.i18nLng()['TECHSPECS']">
            <db-no-data-info i18nMessageKey="NOPAYMENTPAGEDATA" [small]="true"></db-no-data-info>
          </p-card>
        } @else {
          <sps-payment-method-data-card [title]="i18n.i18nLng()['TECHSPECS']"
                                        [editable]="false"
                                        titleColumnWidth="120px"
                                        [tableData]="tableDataPaymentPageTechSpecs">
          </sps-payment-method-data-card>
        }
      </div>
      <div class="col-12">
        <p-card [header]="i18n?.i18nLng()['ADDNEWPAYMENTPAGE']" class="card-secondary">
          <div class="line-height-3">{{ i18n?.i18nLng()['ADDNEWPAYMENTPAGEINFO'] }}</div>
          <ng-template pTemplate="footer">
            <p-button icon="pi pi-plus-circle" [label]="i18n?.i18nLng()['ADDPAYMENTPAGEBUTTON']" variant="outlined" (click)="addPaymentPage()"/>
          </ng-template>
        </p-card>
      </div>
    </div>
  </div>
</div>
